export const URL_API: string = 'https://gfp-all.com/gestaofluidos_v2';
//export const URL_API: string = 'http://localhost:8080';